import React from 'react';

export default function EmptyBox() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140.138"
      height="104.052"
      viewBox="0 0 140.138 104.052">
      <g
        id="Empty_Box_Icon"
        data-name="Empty Box Icon"
        transform="translate(-725.855 -193.897)">
        <path
          id="Path_22829"
          data-name="Path 22829"
          d="M598.9,28.2a3.532,3.532,0,0,0-2-2.3l-50-20.7a3.606,3.606,0,0,0-4.2,1.2L528.5,25.7,498.6,38.2a1.507,1.507,0,0,0-.8,2,1.416,1.416,0,0,0,1.4.9,1.268,1.268,0,0,0,.6-.1l29.7-12.4L579,49.1,529.8,69.3,515.6,50.5a2.652,2.652,0,0,0-.6-.5L461,27.6a1.466,1.466,0,0,0-1.8.5,1.5,1.5,0,0,0,0,1.8l14.4,19.5h0V84a3.476,3.476,0,0,0,2.2,3.2l52,21.5a3.079,3.079,0,0,0,1.3.3,2.768,2.768,0,0,0,1.3-.3l52-21.5a3.476,3.476,0,0,0,2.2-3.2V49.5l13.8-18.3A3.579,3.579,0,0,0,598.9,28.2ZM581.5,84a.55.55,0,0,1-.3.5l-52,21.5a.3.3,0,0,1-.4,0l-52-21.5a.55.55,0,0,1-.3-.5V49.6h0a1.531,1.531,0,0,0-.2-1.3L464.8,32.6l48.6,20.2L528,72.1a1.681,1.681,0,0,0,1.8.5l51.7-21.2Zm14.4-54.6L582.4,47.3,531.8,26.2,545,8.1a.481.481,0,0,1,.6-.2l50,20.7q.3.15.3.3C595.9,29,596,29.3,595.9,29.4Z"
          transform="translate(266.955 188.949)"
          fill="#b3b3b3"
        />
        <path
          id="Path_22830"
          data-name="Path 22830"
          d="M528.5,77.1v23a1,1,0,0,0,2,0v-23a1,1,0,0,0-2,0Z"
          transform="translate(266.955 188.949)"
          fill="#b3b3b3"
        />
        <path
          id="Path_22831"
          data-name="Path 22831"
          d="M519,67.4,484.1,52.5a.985.985,0,0,0-.8,1.8l34.9,14.9a.6.6,0,0,0,.4.1.875.875,0,0,0,.9-.6A.992.992,0,0,0,519,67.4Z"
          transform="translate(266.955 188.949)"
          fill="#b3b3b3"
        />
      </g>
    </svg>
  );
}
